import { userPrivileges } from 'api/User/selectors'
import { changeDate, toggleDatePickerDialog } from 'DatePickerDialog/actions'
import { isFetchingCountries } from 'home/selectors'
import { connect } from 'react-redux'
import { fetchGeneralRevenue } from 'revenue/actions'
import type { State } from 'store/types'

import DateMenu from './DateMenu'

const mapStateToProps = (state: State) => ({
  dateCurrent: state.datePicker.dateCurrent,
  datePickerRange: state.datePicker.range,
  isFetching: isFetchingCountries(state),
  ranges: state.system.ranges,
  todayWarning: state.ui.date.todayWarning,
  typeAnalysis: state.datePicker.typeAnalysis,
  userPrivileges: userPrivileges(state),
})

export default connect(mapStateToProps, {
  changeDate,
  refreshData: fetchGeneralRevenue,
  toggleDatePickerDialog,
})(DateMenu) as any
